var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

// src/vars/index.ts
var vars_exports = {};
__export(vars_exports, {
  $scale: () => scale_exports,
  $semantic: () => semantic_exports,
  $static: () => static_exports
});

// src/vars/scale/index.ts
var scale_exports = {};
__export(scale_exports, {
  color: () => color_exports,
  dimension: () => dimension_exports,
  letterSpacing: () => letterSpacing_exports
});

// src/vars/scale/color.ts
var color_exports = {};
__export(color_exports, {
  blue100: () => blue100,
  blue200: () => blue200,
  blue300: () => blue300,
  blue400: () => blue400,
  blue50: () => blue50,
  blue500: () => blue500,
  blue600: () => blue600,
  blue700: () => blue700,
  blue800: () => blue800,
  blue900: () => blue900,
  blue950: () => blue950,
  blueAlpha100: () => blueAlpha100,
  blueAlpha200: () => blueAlpha200,
  blueAlpha50: () => blueAlpha50,
  carrot100: () => carrot100,
  carrot200: () => carrot200,
  carrot300: () => carrot300,
  carrot400: () => carrot400,
  carrot50: () => carrot50,
  carrot500: () => carrot500,
  carrot600: () => carrot600,
  carrot700: () => carrot700,
  carrot800: () => carrot800,
  carrot900: () => carrot900,
  carrot950: () => carrot950,
  carrotAlpha100: () => carrotAlpha100,
  carrotAlpha200: () => carrotAlpha200,
  carrotAlpha50: () => carrotAlpha50,
  gray00: () => gray00,
  gray100: () => gray100,
  gray200: () => gray200,
  gray300: () => gray300,
  gray400: () => gray400,
  gray50: () => gray50,
  gray500: () => gray500,
  gray600: () => gray600,
  gray700: () => gray700,
  gray800: () => gray800,
  gray900: () => gray900,
  grayAlpha100: () => grayAlpha100,
  grayAlpha200: () => grayAlpha200,
  grayAlpha50: () => grayAlpha50,
  grayAlpha500: () => grayAlpha500,
  green100: () => green100,
  green200: () => green200,
  green300: () => green300,
  green400: () => green400,
  green50: () => green50,
  green500: () => green500,
  green600: () => green600,
  green700: () => green700,
  green800: () => green800,
  green900: () => green900,
  green950: () => green950,
  greenAlpha100: () => greenAlpha100,
  greenAlpha200: () => greenAlpha200,
  greenAlpha50: () => greenAlpha50,
  pink100: () => pink100,
  pink200: () => pink200,
  pink300: () => pink300,
  pink400: () => pink400,
  pink50: () => pink50,
  pink500: () => pink500,
  pink600: () => pink600,
  pink700: () => pink700,
  pink800: () => pink800,
  pink900: () => pink900,
  pink950: () => pink950,
  purple100: () => purple100,
  purple200: () => purple200,
  purple300: () => purple300,
  purple400: () => purple400,
  purple50: () => purple50,
  purple500: () => purple500,
  purple600: () => purple600,
  purple700: () => purple700,
  purple800: () => purple800,
  purple900: () => purple900,
  purple950: () => purple950,
  red100: () => red100,
  red200: () => red200,
  red300: () => red300,
  red400: () => red400,
  red50: () => red50,
  red500: () => red500,
  red600: () => red600,
  red700: () => red700,
  red800: () => red800,
  red900: () => red900,
  red950: () => red950,
  redAlpha100: () => redAlpha100,
  redAlpha200: () => redAlpha200,
  redAlpha50: () => redAlpha50,
  yellow100: () => yellow100,
  yellow200: () => yellow200,
  yellow300: () => yellow300,
  yellow400: () => yellow400,
  yellow50: () => yellow50,
  yellow500: () => yellow500,
  yellow600: () => yellow600,
  yellow700: () => yellow700,
  yellow800: () => yellow800,
  yellow900: () => yellow900,
  yellow950: () => yellow950,
  yellowAlpha100: () => yellowAlpha100,
  yellowAlpha200: () => yellowAlpha200,
  yellowAlpha50: () => yellowAlpha50
});
var gray00 = "var(--seed-scale-color-gray-00)";
var gray50 = "var(--seed-scale-color-gray-50)";
var gray100 = "var(--seed-scale-color-gray-100)";
var gray200 = "var(--seed-scale-color-gray-200)";
var gray300 = "var(--seed-scale-color-gray-300)";
var gray400 = "var(--seed-scale-color-gray-400)";
var gray500 = "var(--seed-scale-color-gray-500)";
var gray600 = "var(--seed-scale-color-gray-600)";
var gray700 = "var(--seed-scale-color-gray-700)";
var gray800 = "var(--seed-scale-color-gray-800)";
var gray900 = "var(--seed-scale-color-gray-900)";
var carrot50 = "var(--seed-scale-color-carrot-50)";
var carrot100 = "var(--seed-scale-color-carrot-100)";
var carrot200 = "var(--seed-scale-color-carrot-200)";
var carrot300 = "var(--seed-scale-color-carrot-300)";
var carrot400 = "var(--seed-scale-color-carrot-400)";
var carrot500 = "var(--seed-scale-color-carrot-500)";
var carrot600 = "var(--seed-scale-color-carrot-600)";
var carrot700 = "var(--seed-scale-color-carrot-700)";
var carrot800 = "var(--seed-scale-color-carrot-800)";
var carrot900 = "var(--seed-scale-color-carrot-900)";
var carrot950 = "var(--seed-scale-color-carrot-950)";
var blue50 = "var(--seed-scale-color-blue-50)";
var blue100 = "var(--seed-scale-color-blue-100)";
var blue200 = "var(--seed-scale-color-blue-200)";
var blue300 = "var(--seed-scale-color-blue-300)";
var blue400 = "var(--seed-scale-color-blue-400)";
var blue500 = "var(--seed-scale-color-blue-500)";
var blue600 = "var(--seed-scale-color-blue-600)";
var blue700 = "var(--seed-scale-color-blue-700)";
var blue800 = "var(--seed-scale-color-blue-800)";
var blue900 = "var(--seed-scale-color-blue-900)";
var blue950 = "var(--seed-scale-color-blue-950)";
var red50 = "var(--seed-scale-color-red-50)";
var red100 = "var(--seed-scale-color-red-100)";
var red200 = "var(--seed-scale-color-red-200)";
var red300 = "var(--seed-scale-color-red-300)";
var red400 = "var(--seed-scale-color-red-400)";
var red500 = "var(--seed-scale-color-red-500)";
var red600 = "var(--seed-scale-color-red-600)";
var red700 = "var(--seed-scale-color-red-700)";
var red800 = "var(--seed-scale-color-red-800)";
var red900 = "var(--seed-scale-color-red-900)";
var red950 = "var(--seed-scale-color-red-950)";
var green50 = "var(--seed-scale-color-green-50)";
var green100 = "var(--seed-scale-color-green-100)";
var green200 = "var(--seed-scale-color-green-200)";
var green300 = "var(--seed-scale-color-green-300)";
var green400 = "var(--seed-scale-color-green-400)";
var green500 = "var(--seed-scale-color-green-500)";
var green600 = "var(--seed-scale-color-green-600)";
var green700 = "var(--seed-scale-color-green-700)";
var green800 = "var(--seed-scale-color-green-800)";
var green900 = "var(--seed-scale-color-green-900)";
var green950 = "var(--seed-scale-color-green-950)";
var yellow50 = "var(--seed-scale-color-yellow-50)";
var yellow100 = "var(--seed-scale-color-yellow-100)";
var yellow200 = "var(--seed-scale-color-yellow-200)";
var yellow300 = "var(--seed-scale-color-yellow-300)";
var yellow400 = "var(--seed-scale-color-yellow-400)";
var yellow500 = "var(--seed-scale-color-yellow-500)";
var yellow600 = "var(--seed-scale-color-yellow-600)";
var yellow700 = "var(--seed-scale-color-yellow-700)";
var yellow800 = "var(--seed-scale-color-yellow-800)";
var yellow900 = "var(--seed-scale-color-yellow-900)";
var yellow950 = "var(--seed-scale-color-yellow-950)";
var pink50 = "var(--seed-scale-color-pink-50)";
var pink100 = "var(--seed-scale-color-pink-100)";
var pink200 = "var(--seed-scale-color-pink-200)";
var pink300 = "var(--seed-scale-color-pink-300)";
var pink400 = "var(--seed-scale-color-pink-400)";
var pink500 = "var(--seed-scale-color-pink-500)";
var pink600 = "var(--seed-scale-color-pink-600)";
var pink700 = "var(--seed-scale-color-pink-700)";
var pink800 = "var(--seed-scale-color-pink-800)";
var pink900 = "var(--seed-scale-color-pink-900)";
var pink950 = "var(--seed-scale-color-pink-950)";
var purple50 = "var(--seed-scale-color-purple-50)";
var purple100 = "var(--seed-scale-color-purple-100)";
var purple200 = "var(--seed-scale-color-purple-200)";
var purple300 = "var(--seed-scale-color-purple-300)";
var purple400 = "var(--seed-scale-color-purple-400)";
var purple500 = "var(--seed-scale-color-purple-500)";
var purple600 = "var(--seed-scale-color-purple-600)";
var purple700 = "var(--seed-scale-color-purple-700)";
var purple800 = "var(--seed-scale-color-purple-800)";
var purple900 = "var(--seed-scale-color-purple-900)";
var purple950 = "var(--seed-scale-color-purple-950)";
var grayAlpha50 = "var(--seed-scale-color-gray-alpha-50)";
var grayAlpha100 = "var(--seed-scale-color-gray-alpha-100)";
var grayAlpha200 = "var(--seed-scale-color-gray-alpha-200)";
var grayAlpha500 = "var(--seed-scale-color-gray-alpha-500)";
var carrotAlpha50 = "var(--seed-scale-color-carrot-alpha-50)";
var carrotAlpha100 = "var(--seed-scale-color-carrot-alpha-100)";
var carrotAlpha200 = "var(--seed-scale-color-carrot-alpha-200)";
var blueAlpha50 = "var(--seed-scale-color-blue-alpha-50)";
var blueAlpha100 = "var(--seed-scale-color-blue-alpha-100)";
var blueAlpha200 = "var(--seed-scale-color-blue-alpha-200)";
var redAlpha50 = "var(--seed-scale-color-red-alpha-50)";
var redAlpha100 = "var(--seed-scale-color-red-alpha-100)";
var redAlpha200 = "var(--seed-scale-color-red-alpha-200)";
var yellowAlpha50 = "var(--seed-scale-color-yellow-alpha-50)";
var yellowAlpha100 = "var(--seed-scale-color-yellow-alpha-100)";
var yellowAlpha200 = "var(--seed-scale-color-yellow-alpha-200)";
var greenAlpha50 = "var(--seed-scale-color-green-alpha-50)";
var greenAlpha100 = "var(--seed-scale-color-green-alpha-100)";
var greenAlpha200 = "var(--seed-scale-color-green-alpha-200)";

// src/vars/scale/dimension.ts
var dimension_exports = {};
__export(dimension_exports, {
  fontSize10: () => fontSize10,
  fontSize100: () => fontSize100,
  fontSize1000: () => fontSize1000,
  fontSize1100: () => fontSize1100,
  fontSize1200: () => fontSize1200,
  fontSize1300: () => fontSize1300,
  fontSize150: () => fontSize150,
  fontSize200: () => fontSize200,
  fontSize25: () => fontSize25,
  fontSize300: () => fontSize300,
  fontSize400: () => fontSize400,
  fontSize50: () => fontSize50,
  fontSize500: () => fontSize500,
  fontSize600: () => fontSize600,
  fontSize700: () => fontSize700,
  fontSize75: () => fontSize75,
  fontSize800: () => fontSize800,
  fontSize900: () => fontSize900
});
var fontSize10 = "var(--seed-scale-dimension-font-size-10)";
var fontSize25 = "var(--seed-scale-dimension-font-size-25)";
var fontSize50 = "var(--seed-scale-dimension-font-size-50)";
var fontSize75 = "var(--seed-scale-dimension-font-size-75)";
var fontSize100 = "var(--seed-scale-dimension-font-size-100)";
var fontSize150 = "var(--seed-scale-dimension-font-size-150)";
var fontSize200 = "var(--seed-scale-dimension-font-size-200)";
var fontSize300 = "var(--seed-scale-dimension-font-size-300)";
var fontSize400 = "var(--seed-scale-dimension-font-size-400)";
var fontSize500 = "var(--seed-scale-dimension-font-size-500)";
var fontSize600 = "var(--seed-scale-dimension-font-size-600)";
var fontSize700 = "var(--seed-scale-dimension-font-size-700)";
var fontSize800 = "var(--seed-scale-dimension-font-size-800)";
var fontSize900 = "var(--seed-scale-dimension-font-size-900)";
var fontSize1000 = "var(--seed-scale-dimension-font-size-1000)";
var fontSize1100 = "var(--seed-scale-dimension-font-size-1100)";
var fontSize1200 = "var(--seed-scale-dimension-font-size-1200)";
var fontSize1300 = "var(--seed-scale-dimension-font-size-1300)";

// src/vars/scale/letterSpacing.ts
var letterSpacing_exports = {};
__export(letterSpacing_exports, {
  narrow200: () => narrow200,
  narrow300: () => narrow300,
  narrow400: () => narrow400,
  none: () => none
});
var none = "var(--seed-scale-letter-spacing-none)";
var narrow200 = "var(--seed-scale-letter-spacing-narrow-200)";
var narrow300 = "var(--seed-scale-letter-spacing-narrow-300)";
var narrow400 = "var(--seed-scale-letter-spacing-narrow-400)";

// src/vars/static/index.ts
var static_exports = {};
__export(static_exports, {
  color: () => color_exports2,
  fontWeight: () => fontWeight_exports,
  lineHeight: () => lineHeight_exports
});

// src/vars/static/color.ts
var color_exports2 = {};
__export(color_exports2, {
  staticBlack: () => staticBlack,
  staticBlackAlpha200: () => staticBlackAlpha200,
  staticBlackAlpha500: () => staticBlackAlpha500,
  staticBlue50: () => staticBlue50,
  staticBlue800: () => staticBlue800,
  staticCarrot50: () => staticCarrot50,
  staticCarrot800: () => staticCarrot800,
  staticGray900: () => staticGray900,
  staticGreen50: () => staticGreen50,
  staticGreen800: () => staticGreen800,
  staticRed50: () => staticRed50,
  staticRed800: () => staticRed800,
  staticWhite: () => staticWhite,
  staticWhiteAlpha200: () => staticWhiteAlpha200,
  staticWhiteAlpha50: () => staticWhiteAlpha50,
  staticYellow50: () => staticYellow50,
  staticYellow800: () => staticYellow800
});
var staticBlack = "var(--seed-static-color-static-black)";
var staticWhite = "var(--seed-static-color-static-white)";
var staticGray900 = "var(--seed-static-color-static-gray-900)";
var staticCarrot50 = "var(--seed-static-color-static-carrot-50)";
var staticCarrot800 = "var(--seed-static-color-static-carrot-800)";
var staticGreen50 = "var(--seed-static-color-static-green-50)";
var staticGreen800 = "var(--seed-static-color-static-green-800)";
var staticYellow50 = "var(--seed-static-color-static-yellow-50)";
var staticYellow800 = "var(--seed-static-color-static-yellow-800)";
var staticRed50 = "var(--seed-static-color-static-red-50)";
var staticRed800 = "var(--seed-static-color-static-red-800)";
var staticBlue50 = "var(--seed-static-color-static-blue-50)";
var staticBlue800 = "var(--seed-static-color-static-blue-800)";
var staticBlackAlpha200 = "var(--seed-static-color-static-black-alpha-200)";
var staticBlackAlpha500 = "var(--seed-static-color-static-black-alpha-500)";
var staticWhiteAlpha50 = "var(--seed-static-color-static-white-alpha-50)";
var staticWhiteAlpha200 = "var(--seed-static-color-static-white-alpha-200)";

// src/vars/static/fontWeight.ts
var fontWeight_exports = {};
__export(fontWeight_exports, {
  bold: () => bold,
  regular: () => regular
});
var regular = "var(--seed-static-font-weight-regular)";
var bold = "var(--seed-static-font-weight-bold)";

// src/vars/static/lineHeight.ts
var lineHeight_exports = {};
__export(lineHeight_exports, {
  staticLarge: () => staticLarge,
  staticMedium: () => staticMedium,
  staticSmall: () => staticSmall
});
var staticSmall = "var(--seed-static-line-height-static-small)";
var staticMedium = "var(--seed-static-line-height-static-medium)";
var staticLarge = "var(--seed-static-line-height-static-large)";

// src/vars/semantic/index.ts
var semantic_exports = {};
__export(semantic_exports, {
  color: () => color_exports3,
  typography: () => typography_exports
});

// src/vars/semantic/color.ts
var color_exports3 = {};
__export(color_exports3, {
  accent: () => accent,
  danger: () => danger,
  dangerLow: () => dangerLow,
  divider1: () => divider1,
  divider2: () => divider2,
  divider3: () => divider3,
  grayActive: () => grayActive,
  grayHover: () => grayHover,
  grayPressed: () => grayPressed,
  inkText: () => inkText,
  inkTextLow: () => inkTextLow,
  onGrayOverlay100: () => onGrayOverlay100,
  onGrayOverlay50: () => onGrayOverlay50,
  onPrimary: () => onPrimary,
  onPrimaryLowOverlay100: () => onPrimaryLowOverlay100,
  onPrimaryLowOverlay200: () => onPrimaryLowOverlay200,
  onPrimaryLowOverlay50: () => onPrimaryLowOverlay50,
  onPrimaryOverlay200: () => onPrimaryOverlay200,
  onPrimaryOverlay50: () => onPrimaryOverlay50,
  overlayDim: () => overlayDim,
  overlayLow: () => overlayLow,
  paperAccent: () => paperAccent,
  paperBackground: () => paperBackground,
  paperContents: () => paperContents,
  paperDefault: () => paperDefault,
  paperDialog: () => paperDialog,
  paperFloating: () => paperFloating,
  paperSheet: () => paperSheet,
  primary: () => primary,
  primaryHover: () => primaryHover,
  primaryLow: () => primaryLow,
  primaryLowActive: () => primaryLowActive,
  primaryLowHover: () => primaryLowHover,
  primaryLowPressed: () => primaryLowPressed,
  primaryPressed: () => primaryPressed,
  secondary: () => secondary,
  secondaryLow: () => secondaryLow,
  success: () => success,
  successLow: () => successLow,
  textSelection: () => textSelection,
  warning: () => warning,
  warningLow: () => warningLow
});
var onPrimary = "var(--seed-semantic-color-on-primary)";
var primary = "var(--seed-semantic-color-primary)";
var primaryLow = "var(--seed-semantic-color-primary-low)";
var secondary = "var(--seed-semantic-color-secondary)";
var secondaryLow = "var(--seed-semantic-color-secondary-low)";
var success = "var(--seed-semantic-color-success)";
var successLow = "var(--seed-semantic-color-success-low)";
var warning = "var(--seed-semantic-color-warning)";
var warningLow = "var(--seed-semantic-color-warning-low)";
var danger = "var(--seed-semantic-color-danger)";
var dangerLow = "var(--seed-semantic-color-danger-low)";
var overlayLow = "var(--seed-semantic-color-overlay-low)";
var overlayDim = "var(--seed-semantic-color-overlay-dim)";
var paperSheet = "var(--seed-semantic-color-paper-sheet)";
var paperDialog = "var(--seed-semantic-color-paper-dialog)";
var paperFloating = "var(--seed-semantic-color-paper-floating)";
var paperContents = "var(--seed-semantic-color-paper-contents)";
var paperDefault = "var(--seed-semantic-color-paper-default)";
var paperBackground = "var(--seed-semantic-color-paper-background)";
var paperAccent = "var(--seed-semantic-color-paper-accent)";
var primaryHover = "var(--seed-semantic-color-primary-hover)";
var primaryPressed = "var(--seed-semantic-color-primary-pressed)";
var primaryLowHover = "var(--seed-semantic-color-primary-low-hover)";
var primaryLowActive = "var(--seed-semantic-color-primary-low-active)";
var primaryLowPressed = "var(--seed-semantic-color-primary-low-pressed)";
var grayHover = "var(--seed-semantic-color-gray-hover)";
var grayPressed = "var(--seed-semantic-color-gray-pressed)";
var onPrimaryOverlay50 = "var(--seed-semantic-color-on-primary-overlay-50)";
var onPrimaryOverlay200 = "var(--seed-semantic-color-on-primary-overlay-200)";
var onPrimaryLowOverlay50 = "var(--seed-semantic-color-on-primary-low-overlay-50)";
var onPrimaryLowOverlay100 = "var(--seed-semantic-color-on-primary-low-overlay-100)";
var onPrimaryLowOverlay200 = "var(--seed-semantic-color-on-primary-low-overlay-200)";
var onGrayOverlay50 = "var(--seed-semantic-color-on-gray-overlay-50)";
var onGrayOverlay100 = "var(--seed-semantic-color-on-gray-overlay-100)";
var textSelection = "var(--seed-semantic-color-text-selection)";
var divider1 = "var(--seed-semantic-color-divider-1)";
var divider2 = "var(--seed-semantic-color-divider-2)";
var divider3 = "var(--seed-semantic-color-divider-3)";
var accent = "var(--seed-semantic-color-accent)";
var inkText = "var(--seed-semantic-color-ink-text)";
var inkTextLow = "var(--seed-semantic-color-ink-text-low)";
var grayActive = "var(--seed-semantic-color-gray-active)";

// src/vars/semantic/typography.ts
var typography_exports = {};
__export(typography_exports, {
  bodyL1Bold: () => bodyL1Bold,
  bodyL1Regular: () => bodyL1Regular,
  bodyL2Bold: () => bodyL2Bold,
  bodyL2Regular: () => bodyL2Regular,
  bodyM1Bold: () => bodyM1Bold,
  bodyM1Regular: () => bodyM1Regular,
  bodyM2Bold: () => bodyM2Bold,
  bodyM2Regular: () => bodyM2Regular,
  caption1Bold: () => caption1Bold,
  caption1Regular: () => caption1Regular,
  caption2Bold: () => caption2Bold,
  caption2Regular: () => caption2Regular,
  h1: () => h1,
  h2: () => h2,
  h3: () => h3,
  h4: () => h4,
  label1Bold: () => label1Bold,
  label1Regular: () => label1Regular,
  label2Bold: () => label2Bold,
  label2Regular: () => label2Regular,
  label3Bold: () => label3Bold,
  label3Regular: () => label3Regular,
  label4Bold: () => label4Bold,
  label4Regular: () => label4Regular,
  label5Bold: () => label5Bold,
  label5Regular: () => label5Regular,
  label6Bold: () => label6Bold,
  label6Regular: () => label6Regular,
  subtitle1Bold: () => subtitle1Bold,
  subtitle1Regular: () => subtitle1Regular,
  subtitle2Bold: () => subtitle2Bold,
  subtitle2Regular: () => subtitle2Regular,
  title1Bold: () => title1Bold,
  title1Regular: () => title1Regular,
  title2Bold: () => title2Bold,
  title2Regular: () => title2Regular,
  title3Bold: () => title3Bold,
  title3Regular: () => title3Regular
});
var h1 = {
  fontSize: "var(--seed-semantic-typography-h1-font-size)",
  fontWeight: "var(--seed-semantic-typography-h1-font-weight)",
  lineHeight: "var(--seed-semantic-typography-h1-line-height)",
  letterSpacing: "var(--seed-semantic-typography-h1-letter-spacing)"
};
var h2 = {
  fontSize: "var(--seed-semantic-typography-h2-font-size)",
  fontWeight: "var(--seed-semantic-typography-h2-font-weight)",
  lineHeight: "var(--seed-semantic-typography-h2-line-height)",
  letterSpacing: "var(--seed-semantic-typography-h2-letter-spacing)"
};
var h3 = {
  fontSize: "var(--seed-semantic-typography-h3-font-size)",
  fontWeight: "var(--seed-semantic-typography-h3-font-weight)",
  lineHeight: "var(--seed-semantic-typography-h3-line-height)",
  letterSpacing: "var(--seed-semantic-typography-h3-letter-spacing)"
};
var h4 = {
  fontSize: "var(--seed-semantic-typography-h4-font-size)",
  fontWeight: "var(--seed-semantic-typography-h4-font-weight)",
  lineHeight: "var(--seed-semantic-typography-h4-line-height)",
  letterSpacing: "var(--seed-semantic-typography-h4-letter-spacing)"
};
var title1Bold = {
  fontSize: "var(--seed-semantic-typography-title1-bold-font-size)",
  fontWeight: "var(--seed-semantic-typography-title1-bold-font-weight)",
  lineHeight: "var(--seed-semantic-typography-title1-bold-line-height)",
  letterSpacing: "var(--seed-semantic-typography-title1-bold-letter-spacing)"
};
var title1Regular = {
  fontSize: "var(--seed-semantic-typography-title1-regular-font-size)",
  fontWeight: "var(--seed-semantic-typography-title1-regular-font-weight)",
  lineHeight: "var(--seed-semantic-typography-title1-regular-line-height)",
  letterSpacing: "var(--seed-semantic-typography-title1-regular-letter-spacing)"
};
var title2Bold = {
  fontSize: "var(--seed-semantic-typography-title2-bold-font-size)",
  fontWeight: "var(--seed-semantic-typography-title2-bold-font-weight)",
  lineHeight: "var(--seed-semantic-typography-title2-bold-line-height)",
  letterSpacing: "var(--seed-semantic-typography-title2-bold-letter-spacing)"
};
var title2Regular = {
  fontSize: "var(--seed-semantic-typography-title2-regular-font-size)",
  fontWeight: "var(--seed-semantic-typography-title2-regular-font-weight)",
  lineHeight: "var(--seed-semantic-typography-title2-regular-line-height)",
  letterSpacing: "var(--seed-semantic-typography-title2-regular-letter-spacing)"
};
var title3Bold = {
  fontSize: "var(--seed-semantic-typography-title3-bold-font-size)",
  fontWeight: "var(--seed-semantic-typography-title3-bold-font-weight)",
  lineHeight: "var(--seed-semantic-typography-title3-bold-line-height)",
  letterSpacing: "var(--seed-semantic-typography-title3-bold-letter-spacing)"
};
var title3Regular = {
  fontSize: "var(--seed-semantic-typography-title3-regular-font-size)",
  fontWeight: "var(--seed-semantic-typography-title3-regular-font-weight)",
  lineHeight: "var(--seed-semantic-typography-title3-regular-line-height)",
  letterSpacing: "var(--seed-semantic-typography-title3-regular-letter-spacing)"
};
var subtitle1Bold = {
  fontSize: "var(--seed-semantic-typography-subtitle1-bold-font-size)",
  fontWeight: "var(--seed-semantic-typography-subtitle1-bold-font-weight)",
  lineHeight: "var(--seed-semantic-typography-subtitle1-bold-line-height)",
  letterSpacing: "var(--seed-semantic-typography-subtitle1-bold-letter-spacing)"
};
var subtitle1Regular = {
  fontSize: "var(--seed-semantic-typography-subtitle1-regular-font-size)",
  fontWeight: "var(--seed-semantic-typography-subtitle1-regular-font-weight)",
  lineHeight: "var(--seed-semantic-typography-subtitle1-regular-line-height)",
  letterSpacing: "var(--seed-semantic-typography-subtitle1-regular-letter-spacing)"
};
var subtitle2Bold = {
  fontSize: "var(--seed-semantic-typography-subtitle2-bold-font-size)",
  fontWeight: "var(--seed-semantic-typography-subtitle2-bold-font-weight)",
  lineHeight: "var(--seed-semantic-typography-subtitle2-bold-line-height)",
  letterSpacing: "var(--seed-semantic-typography-subtitle2-bold-letter-spacing)"
};
var subtitle2Regular = {
  fontSize: "var(--seed-semantic-typography-subtitle2-regular-font-size)",
  fontWeight: "var(--seed-semantic-typography-subtitle2-regular-font-weight)",
  lineHeight: "var(--seed-semantic-typography-subtitle2-regular-line-height)",
  letterSpacing: "var(--seed-semantic-typography-subtitle2-regular-letter-spacing)"
};
var bodyL1Bold = {
  fontSize: "var(--seed-semantic-typography-body-l1-bold-font-size)",
  fontWeight: "var(--seed-semantic-typography-body-l1-bold-font-weight)",
  lineHeight: "var(--seed-semantic-typography-body-l1-bold-line-height)",
  letterSpacing: "var(--seed-semantic-typography-body-l1-bold-letter-spacing)"
};
var bodyL1Regular = {
  fontSize: "var(--seed-semantic-typography-body-l1-regular-font-size)",
  fontWeight: "var(--seed-semantic-typography-body-l1-regular-font-weight)",
  lineHeight: "var(--seed-semantic-typography-body-l1-regular-line-height)",
  letterSpacing: "var(--seed-semantic-typography-body-l1-regular-letter-spacing)"
};
var bodyL2Bold = {
  fontSize: "var(--seed-semantic-typography-body-l2-bold-font-size)",
  fontWeight: "var(--seed-semantic-typography-body-l2-bold-font-weight)",
  lineHeight: "var(--seed-semantic-typography-body-l2-bold-line-height)",
  letterSpacing: "var(--seed-semantic-typography-body-l2-bold-letter-spacing)"
};
var bodyL2Regular = {
  fontSize: "var(--seed-semantic-typography-body-l2-regular-font-size)",
  fontWeight: "var(--seed-semantic-typography-body-l2-regular-font-weight)",
  lineHeight: "var(--seed-semantic-typography-body-l2-regular-line-height)",
  letterSpacing: "var(--seed-semantic-typography-body-l2-regular-letter-spacing)"
};
var bodyM1Bold = {
  fontSize: "var(--seed-semantic-typography-body-m1-bold-font-size)",
  fontWeight: "var(--seed-semantic-typography-body-m1-bold-font-weight)",
  lineHeight: "var(--seed-semantic-typography-body-m1-bold-line-height)",
  letterSpacing: "var(--seed-semantic-typography-body-m1-bold-letter-spacing)"
};
var bodyM1Regular = {
  fontSize: "var(--seed-semantic-typography-body-m1-regular-font-size)",
  fontWeight: "var(--seed-semantic-typography-body-m1-regular-font-weight)",
  lineHeight: "var(--seed-semantic-typography-body-m1-regular-line-height)",
  letterSpacing: "var(--seed-semantic-typography-body-m1-regular-letter-spacing)"
};
var bodyM2Bold = {
  fontSize: "var(--seed-semantic-typography-body-m2-bold-font-size)",
  fontWeight: "var(--seed-semantic-typography-body-m2-bold-font-weight)",
  lineHeight: "var(--seed-semantic-typography-body-m2-bold-line-height)",
  letterSpacing: "var(--seed-semantic-typography-body-m2-bold-letter-spacing)"
};
var bodyM2Regular = {
  fontSize: "var(--seed-semantic-typography-body-m2-regular-font-size)",
  fontWeight: "var(--seed-semantic-typography-body-m2-regular-font-weight)",
  lineHeight: "var(--seed-semantic-typography-body-m2-regular-line-height)",
  letterSpacing: "var(--seed-semantic-typography-body-m2-regular-letter-spacing)"
};
var caption1Bold = {
  fontSize: "var(--seed-semantic-typography-caption1-bold-font-size)",
  fontWeight: "var(--seed-semantic-typography-caption1-bold-font-weight)",
  lineHeight: "var(--seed-semantic-typography-caption1-bold-line-height)",
  letterSpacing: "var(--seed-semantic-typography-caption1-bold-letter-spacing)"
};
var caption1Regular = {
  fontSize: "var(--seed-semantic-typography-caption1-regular-font-size)",
  fontWeight: "var(--seed-semantic-typography-caption1-regular-font-weight)",
  lineHeight: "var(--seed-semantic-typography-caption1-regular-line-height)",
  letterSpacing: "var(--seed-semantic-typography-caption1-regular-letter-spacing)"
};
var caption2Bold = {
  fontSize: "var(--seed-semantic-typography-caption2-bold-font-size)",
  fontWeight: "var(--seed-semantic-typography-caption2-bold-font-weight)",
  lineHeight: "var(--seed-semantic-typography-caption2-bold-line-height)",
  letterSpacing: "var(--seed-semantic-typography-caption2-bold-letter-spacing)"
};
var caption2Regular = {
  fontSize: "var(--seed-semantic-typography-caption2-regular-font-size)",
  fontWeight: "var(--seed-semantic-typography-caption2-regular-font-weight)",
  lineHeight: "var(--seed-semantic-typography-caption2-regular-line-height)",
  letterSpacing: "var(--seed-semantic-typography-caption2-regular-letter-spacing)"
};
var label1Bold = {
  fontSize: "var(--seed-semantic-typography-label1-bold-font-size)",
  fontWeight: "var(--seed-semantic-typography-label1-bold-font-weight)",
  lineHeight: "var(--seed-semantic-typography-label1-bold-line-height)",
  letterSpacing: "var(--seed-semantic-typography-label1-bold-letter-spacing)"
};
var label1Regular = {
  fontSize: "var(--seed-semantic-typography-label1-regular-font-size)",
  fontWeight: "var(--seed-semantic-typography-label1-regular-font-weight)",
  lineHeight: "var(--seed-semantic-typography-label1-regular-line-height)",
  letterSpacing: "var(--seed-semantic-typography-label1-regular-letter-spacing)"
};
var label2Bold = {
  fontSize: "var(--seed-semantic-typography-label2-bold-font-size)",
  fontWeight: "var(--seed-semantic-typography-label2-bold-font-weight)",
  lineHeight: "var(--seed-semantic-typography-label2-bold-line-height)",
  letterSpacing: "var(--seed-semantic-typography-label2-bold-letter-spacing)"
};
var label2Regular = {
  fontSize: "var(--seed-semantic-typography-label2-regular-font-size)",
  fontWeight: "var(--seed-semantic-typography-label2-regular-font-weight)",
  lineHeight: "var(--seed-semantic-typography-label2-regular-line-height)",
  letterSpacing: "var(--seed-semantic-typography-label2-regular-letter-spacing)"
};
var label3Bold = {
  fontSize: "var(--seed-semantic-typography-label3-bold-font-size)",
  fontWeight: "var(--seed-semantic-typography-label3-bold-font-weight)",
  lineHeight: "var(--seed-semantic-typography-label3-bold-line-height)",
  letterSpacing: "var(--seed-semantic-typography-label3-bold-letter-spacing)"
};
var label3Regular = {
  fontSize: "var(--seed-semantic-typography-label3-regular-font-size)",
  fontWeight: "var(--seed-semantic-typography-label3-regular-font-weight)",
  lineHeight: "var(--seed-semantic-typography-label3-regular-line-height)",
  letterSpacing: "var(--seed-semantic-typography-label3-regular-letter-spacing)"
};
var label4Bold = {
  fontSize: "var(--seed-semantic-typography-label4-bold-font-size)",
  fontWeight: "var(--seed-semantic-typography-label4-bold-font-weight)",
  lineHeight: "var(--seed-semantic-typography-label4-bold-line-height)",
  letterSpacing: "var(--seed-semantic-typography-label4-bold-letter-spacing)"
};
var label4Regular = {
  fontSize: "var(--seed-semantic-typography-label4-regular-font-size)",
  fontWeight: "var(--seed-semantic-typography-label4-regular-font-weight)",
  lineHeight: "var(--seed-semantic-typography-label4-regular-line-height)",
  letterSpacing: "var(--seed-semantic-typography-label4-regular-letter-spacing)"
};
var label5Bold = {
  fontSize: "var(--seed-semantic-typography-label5-bold-font-size)",
  fontWeight: "var(--seed-semantic-typography-label5-bold-font-weight)",
  lineHeight: "var(--seed-semantic-typography-label5-bold-line-height)",
  letterSpacing: "var(--seed-semantic-typography-label5-bold-letter-spacing)"
};
var label5Regular = {
  fontSize: "var(--seed-semantic-typography-label5-regular-font-size)",
  fontWeight: "var(--seed-semantic-typography-label5-regular-font-weight)",
  lineHeight: "var(--seed-semantic-typography-label5-regular-line-height)",
  letterSpacing: "var(--seed-semantic-typography-label5-regular-letter-spacing)"
};
var label6Bold = {
  fontSize: "var(--seed-semantic-typography-label6-bold-font-size)",
  fontWeight: "var(--seed-semantic-typography-label6-bold-font-weight)",
  lineHeight: "var(--seed-semantic-typography-label6-bold-line-height)",
  letterSpacing: "var(--seed-semantic-typography-label6-bold-letter-spacing)"
};
var label6Regular = {
  fontSize: "var(--seed-semantic-typography-label6-regular-font-size)",
  fontWeight: "var(--seed-semantic-typography-label6-regular-font-weight)",
  lineHeight: "var(--seed-semantic-typography-label6-regular-line-height)",
  letterSpacing: "var(--seed-semantic-typography-label6-regular-letter-spacing)"
};

// src/classNames/index.ts
var classNames_exports = {};
__export(classNames_exports, {
  $semantic: () => semantic_exports2
});

// src/classNames/semantic/index.ts
var semantic_exports2 = {};
__export(semantic_exports2, {
  typography: () => typography_exports2
});

// src/classNames/semantic/typography.ts
var typography_exports2 = {};
__export(typography_exports2, {
  bodyL1Bold: () => bodyL1Bold2,
  bodyL1Regular: () => bodyL1Regular2,
  bodyL2Bold: () => bodyL2Bold2,
  bodyL2Regular: () => bodyL2Regular2,
  bodyM1Bold: () => bodyM1Bold2,
  bodyM1Regular: () => bodyM1Regular2,
  bodyM2Bold: () => bodyM2Bold2,
  bodyM2Regular: () => bodyM2Regular2,
  caption1Bold: () => caption1Bold2,
  caption1Regular: () => caption1Regular2,
  caption2Bold: () => caption2Bold2,
  caption2Regular: () => caption2Regular2,
  h1: () => h12,
  h2: () => h22,
  h3: () => h32,
  h4: () => h42,
  label1Bold: () => label1Bold2,
  label1Regular: () => label1Regular2,
  label2Bold: () => label2Bold2,
  label2Regular: () => label2Regular2,
  label3Bold: () => label3Bold2,
  label3Regular: () => label3Regular2,
  label4Bold: () => label4Bold2,
  label4Regular: () => label4Regular2,
  label5Bold: () => label5Bold2,
  label5Regular: () => label5Regular2,
  label6Bold: () => label6Bold2,
  label6Regular: () => label6Regular2,
  subtitle1Bold: () => subtitle1Bold2,
  subtitle1Regular: () => subtitle1Regular2,
  subtitle2Bold: () => subtitle2Bold2,
  subtitle2Regular: () => subtitle2Regular2,
  title1Bold: () => title1Bold2,
  title1Regular: () => title1Regular2,
  title2Bold: () => title2Bold2,
  title2Regular: () => title2Regular2,
  title3Bold: () => title3Bold2,
  title3Regular: () => title3Regular2
});
var h12 = "seed-semantic-typography-h1";
var h22 = "seed-semantic-typography-h2";
var h32 = "seed-semantic-typography-h3";
var h42 = "seed-semantic-typography-h4";
var title1Bold2 = "seed-semantic-typography-title1-bold";
var title1Regular2 = "seed-semantic-typography-title1-regular";
var title2Bold2 = "seed-semantic-typography-title2-bold";
var title2Regular2 = "seed-semantic-typography-title2-regular";
var title3Bold2 = "seed-semantic-typography-title3-bold";
var title3Regular2 = "seed-semantic-typography-title3-regular";
var subtitle1Bold2 = "seed-semantic-typography-subtitle1-bold";
var subtitle1Regular2 = "seed-semantic-typography-subtitle1-regular";
var subtitle2Bold2 = "seed-semantic-typography-subtitle2-bold";
var subtitle2Regular2 = "seed-semantic-typography-subtitle2-regular";
var bodyL1Bold2 = "seed-semantic-typography-body-l1-bold";
var bodyL1Regular2 = "seed-semantic-typography-body-l1-regular";
var bodyL2Bold2 = "seed-semantic-typography-body-l2-bold";
var bodyL2Regular2 = "seed-semantic-typography-body-l2-regular";
var bodyM1Bold2 = "seed-semantic-typography-body-m1-bold";
var bodyM1Regular2 = "seed-semantic-typography-body-m1-regular";
var bodyM2Bold2 = "seed-semantic-typography-body-m2-bold";
var bodyM2Regular2 = "seed-semantic-typography-body-m2-regular";
var caption1Bold2 = "seed-semantic-typography-caption1-bold";
var caption1Regular2 = "seed-semantic-typography-caption1-regular";
var caption2Bold2 = "seed-semantic-typography-caption2-bold";
var caption2Regular2 = "seed-semantic-typography-caption2-regular";
var label1Bold2 = "seed-semantic-typography-label1-bold";
var label1Regular2 = "seed-semantic-typography-label1-regular";
var label2Bold2 = "seed-semantic-typography-label2-bold";
var label2Regular2 = "seed-semantic-typography-label2-regular";
var label3Bold2 = "seed-semantic-typography-label3-bold";
var label3Regular2 = "seed-semantic-typography-label3-regular";
var label4Bold2 = "seed-semantic-typography-label4-bold";
var label4Regular2 = "seed-semantic-typography-label4-regular";
var label5Bold2 = "seed-semantic-typography-label5-bold";
var label5Regular2 = "seed-semantic-typography-label5-regular";
var label6Bold2 = "seed-semantic-typography-label6-bold";
var label6Regular2 = "seed-semantic-typography-label6-regular";
export { classNames_exports as classNames, vars_exports as vars };
/*! For license information please see index.mjs.LEGAL.txt */